export default {
  title: 'Salva contatto e dati di pagamento',
  form: {
    remember_me: {
      label: 'Crea un account per un checkout più rapido sui prossimi ordini.',
    },
  },
};
